import { ApiRequestStore } from "../../../common/apiRequest.store"

class PerformanceApproveStore extends ApiRequestStore {}
class PerformanceDeleteStore extends ApiRequestStore {}

export const performanceApproveStore: PerformanceApproveStore = new PerformanceApproveStore()
export const performanceDeleteStore: PerformanceDeleteStore = new PerformanceDeleteStore()